import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Product } from './mockData';
import { Layers, ArrowRight, Calendar } from 'lucide-react';
interface ProductGridProps {
  products: Product[];
  onSelectProduct: (product: Product) => void;
}
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function ProductGrid({
  products,
  onSelectProduct
}: ProductGridProps) {
  return <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 min-[1920px]:grid-cols-6 min-[2560px]:grid-cols-7 gap-5 w-full px-4 sm:px-6 lg:px-10 2xl:px-16 pb-12" data-id="element-290">
      {products.map(product => {
      return <motion.button key={product.id} variants={item} whileHover={{
        y: -4
      }} whileTap={{
        scale: 0.99
      }} transition={{
        duration: 0.2
      }} onClick={() => onSelectProduct(product)} className="group relative bg-white rounded-2xl border border-gray-200 hover:border-[#E87722]/40 shadow-sm hover:shadow-lg cursor-pointer transition-all overflow-hidden flex flex-col text-left" data-id="element-291">
            {/* Top accent bar */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#E87722] to-[#F59E42] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-292" />

            <div className="p-6 flex-1" data-id="element-293">
              <div className="flex justify-between items-start mb-6" data-id="element-294">
                <div className="relative" data-id="element-295">
                  <div className="absolute inset-0 bg-[#E87722]/10 rounded-xl blur-md group-hover:blur-lg transition-all" data-id="element-296" />
                  <div className="relative w-12 h-12 bg-gradient-to-br from-[#FFF4EC] to-[#FFE5D0] rounded-xl flex items-center justify-center border border-[#E87722]/10" data-id="element-297">
                    <Layers className="w-5 h-5 text-[#E87722]" strokeWidth={2.25} data-id="element-298" />
                  </div>
                </div>
              </div>

              <div className="mb-3" data-id="element-299">
                <div className="text-[11px] font-mono font-medium text-gray-400 mb-1" data-id="element-300">
                  {product.productNumber}
                </div>
                <h3 className="text-[17px] font-semibold text-gray-900 leading-snug line-clamp-2 group-hover:text-[#E87722] transition-colors" data-id="element-301">
                  {product.name}
                </h3>
              </div>

              <div className="flex items-baseline gap-1.5" data-id="element-302">
                <span className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-303">
                  {product.batchCount}
                </span>
                <span className="text-sm text-gray-500" data-id="element-304">Chargen</span>
              </div>
            </div>

            <div className="px-6 py-3.5 border-t border-gray-100 bg-gray-50/60 flex items-center justify-between" data-id="element-305">
              <div className="flex items-center gap-1.5 text-xs text-gray-500" data-id="element-306">
                <Calendar className="w-3.5 h-3.5" data-id="element-307" />
                <span data-id="element-308">Letzte Aktivität:</span>
                <span className="tabular-nums" data-id="element-309">
                  {product.lastProductionDate}
                </span>
              </div>
              <div className="flex items-center gap-1 text-xs font-medium text-gray-400 group-hover:text-[#E87722] transition-all" data-id="element-310">
                <span className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" data-id="element-311">
                  Öffnen
                </span>
                <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" data-id="element-312" />
              </div>
            </div>
          </motion.button>;
    })}
    </motion.div>;
}